import { createSpecimenPopulationSnapshot } from "./specimenState";

const INITIAL_SPECIMEN_UI_KEY_PATH = "case.specimens.0.uiKey";

interface AccessioningFormForNewCase<
  TValues extends { case: { specimens: unknown[] } }
> {
  reset: () => void;
  setFieldValue: (path: string, value: string) => void;
  getValues: () => TValues;
  resetDirty: (values: TValues) => void;
  resetTouched: () => void;
}

export function resetAccessioningFormForNewCase<
  TValues extends { case: { specimens: unknown[] } }
>(form: AccessioningFormForNewCase<TValues>, uiKey: string): string {
  form.reset();
  form.setFieldValue(INITIAL_SPECIMEN_UI_KEY_PATH, uiKey);
  const resetValues = form.getValues();
  form.resetDirty(resetValues);
  form.resetTouched();
  return createSpecimenPopulationSnapshot(resetValues.case.specimens);
}
